module.exports = __webpack_public_path__ + "img/s_3.1f15c95c.png";